module.exports = __webpack_public_path__ + "img/kj_icon3.b255cf87.png";